import React from 'react';
import AuthSplitLayout from 'layouts/AuthSplitLayout';
import WaitlistForm from './components/WaitlistForm';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import bgImg from 'assets/img/generic/15.jpg';

const Waitlist = () => {
  const { t } = useTranslation();
  return (
    <AuthSplitLayout
      bgProps={{ image: bgImg, position: '50% 25%' }}
      contentColClass="col-xxl-9"
    >
      <h3>{t('WAITLIST.TITLE')}</h3>
      <p className="text-muted mb-4">
        {t('WAITLIST.SUBTITLE')}
      </p>
      <WaitlistForm />
      <p className="pt-3 mb-0 fs--1 text-600">
        {t('WAITLIST.ALREADY_APPLIED')}
        <br />
        <Button
          as={Link}
          variant="outline-primary"
          className="mt-2 px-4"
          to="/waitlist/status"
        >
          {t('WAITLIST.CHECK_STATUS')}
        </Button>
      </p>
    </AuthSplitLayout>
  );
};

export default Waitlist;
